import { CadorReference } from './cador-reference';

export class ProfessionalProject {

    projectType: CadorReference;

    intendedProfession: string;

    specialization: string;

    comment: string;


}
